import React from "react";
import { Icon } from "@clarkinc/zest-design-system";
import Prop65Warning from "./Prop65Warning";
import AB1200Warning from "./AB1200Warning";

interface WarningProps {
  displayAb1200Disclaimer?: boolean;
  isStandardTemplate?: boolean;
  prop65Warning?: string;
  ab1200Chemicals?: string[];
  spanishAb1200Chemicals?: string[];
}

const Warnings = ({
  displayAb1200Disclaimer,
  isStandardTemplate,
  prop65Warning,
  ab1200Chemicals,
  spanishAb1200Chemicals,
}: WarningProps) => {
  const showSeparatorIcon = prop65Warning && displayAb1200Disclaimer;
  const showArrowIcon = !showSeparatorIcon;

  const baseClasses = "disclaimer-container flex leading-4 max-w-[800px] ";
  const iconClass = showArrowIcon ? "show-arrow-icon " : "show-separator-icon ";
  const templateClass = isStandardTemplate
    ? "disclaimer-standard-template"
    : "disclaimer-expanded-template";
  const disclaimerContainerClasses = `${baseClasses}${iconClass}${templateClass}`;

  return (
    <>
      {prop65Warning || displayAb1200Disclaimer ? (
        <div className={disclaimerContainerClasses}>
          <div className="warning-state-container">
            <img
              alt=""
              className="details-disclaimer-icon h-3.5 mr-1.5 w-3.5"
              src="/uploads/design/2018/7/prop-65-warning-icon.png"
            />
            <span className="font-bold leading-4 mr-1 text-base">
              Attention CA Residents:
            </span>
          </div>
          <div className="flex items-center">
            {prop65Warning && (
              <Prop65Warning prop65Disclaimer={prop65Warning} />
            )}
            {showSeparatorIcon && (
              <span className="text-gray-300">&#65372;</span>
            )}
            {displayAb1200Disclaimer && (
              <AB1200Warning
                ab1200Chemicals={ab1200Chemicals}
                spanishAb1200Chemicals={spanishAb1200Chemicals}
              />
            )}
            {showArrowIcon && (
              <Icon
                className="fill-green-500 hover:fill-green-900"
                name="ri-arrow-right-s-line"
                data-testid="warning-arrow"
                size="xsmall"
                theme="wss"
              />
            )}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Warnings;
